<template>
    <div>
        <el-page-header @back="goBack" content="健康管理助理资料详情"></el-page-header>
        <div class="docker-detail-header" v-if="role_id != 2">
            <el-button type="success" @click="edit">编辑</el-button>
            <el-button type="primary" @click="importinfo">导出资料</el-button>
        </div>
        <Box style="margin-top: 20px;">
            <template #body>
                <table class="table">
                    <tbody>
                    <tr>
                        <td class="dockert_img_td" rowspan="8">
                            <el-image style="width: 100%;" :src="user_avatar"></el-image>
                        </td>
                        <td class="docker_title_td">健康管理助理姓名</td>
                        <td class="docker_value_td">{{ user_name }}</td>
                        <td class="docker_title_td">状态</td>
                        <td class="docker_value_td">{{ status }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">手机号码</td>
                        <td class="docker_value_td">{{ mobile }}</td>
                        <td class="docker_title_td">身份证号</td>
                        <td class="docker_value_td">{{ idcard }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">单位</td>
                        <td class="docker_value_td">{{hospital_name}}</td>
                        <td class="docker_title_td">银行卡号</td>
                        <td class="docker_value_td">{{bank_card}}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">服务健康管理专家</td>
                        <td class="docker_value_td"><el-button type="text" @click="goDoctorDetail({user_id: doctor_id})">{{ doctor_name }}</el-button></td>
                        <td class="docker_title_td">签约时间</td>
                        <td class="docker_value_td">{{ start_date }}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">健康管理专家手机号码</td>
                        <td class="docker_value_td">{{ doctor_mobile }}</td>
                        <td class="docker_title_td">健康管理专家状态</td>
                        <td class="docker_value_td">{{doctor_status == 1 ? '启用':'停用'}}</td>
                    </tr>
                    <tr>
                        <td class="docker_title_td">专长</td>
                        <td class="docker_value_td">{{ introduction }}</td>
                        <td class="docker_title_td">职称</td>
                        <td class="docker_value_td" v-if="posistion">{{title_name}}({{posistion}})</td>
                        <td class="docker_value_td" v-if="!posistion">{{title_name}}</td>
                    </tr>
                    <tr v-if="role_id != 2 && child_role_id == 0">
                        <td class="docker_title_td">运营负责人</td>
                        <td class="docker_value_td">{{ admin_user_name }}</td>
                        <td class="docker_title_td">负责人电话</td>
                        <td class="docker_value_td">{{ admin_user_mobile }}</td>
                    </tr>
                    </tbody>
                </table>
            </template>
        </Box>
        <div id="statistics_box" class="message_box">
            <p class="message_title">健康管理助理统计信息</p>
            <table class="table">
                <tbody>
                <tr>
                    <td>预约处理数量</td>
                    <td>预约未响应数量</td>
                    <td>等待会面数量</td>
                    <td>会面中断数量</td>
                    <td>会面完成数量</td>
                </tr>
                <tr>
                    <td>{{ needDeal }}</td>
                    <td>{{ noReplyCount }}</td>
                    <td>{{ beforeMeetCount }}</td>
                    <td>{{ brokenMeetCount }}</td>
                    <td>{{ finishMeet }}</td>
                </tr>
                </tbody>
            </table>
        </div>
        <div class="table_message_box">
            <p style="float: left">预约信息记录</p>
            <div class="search_data">
<!--                <el-input @change="searchReservation" v-model="search_reservation_data" placeholder="搜索"/>-->
            </div>
            <el-table ref="multipleTable" :data="reservationListing" border style="width: 100%">
                <el-table-column prop="reservation_id" label="预约编号" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="doctor_name" label="健康管理专家" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="doctor_mobile" label="健康管理专家联系电话" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="status" label="预约状态" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="book_date" label="预约会面时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="remark" label="备注" align="center" label-class-name="label"></el-table-column>
            </el-table>
            <el-pagination class="mg-20 ta-r" background layout="total, sizes, prev, pager, next, jumper"
                           :page-sizes="[5,10, 25, 50, 100]" :total="service_total" :page-size="service_perpage"
                           :current-page="service_page"
                           @current-change="serviceChangePage" @size-change="serviceChangeSite"></el-pagination>
            <span>
				<el-button @click="goReservationListing">查看更多预约信息</el-button>
			</span>
        </div>
        <div class="table_message_box">
            <p style="float: left">服务健康管理专家列表</p>
            <span style="float: right;" v-if="role_id != 2">
				<el-button @click="addConsultant">{{ bindedDoctor != [] ? '重新绑定' : '新增绑定' }}</el-button>
			</span>
            <el-table ref="multipleTable" :data="bindedDoctor" border style="width: 100%">
                <!--				<el-table-column prop="user_id" label="ID" align="center" label-class-name="label"></el-table-column>-->
                <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="mobile" label="登录手机号码" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="user_name" label="姓名" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="" label="操作" align="center" label-class-name="label" v-slot="scope">
                    <el-button @click="goDoctorDetail(scope.row)" type="text" size="small">
                        健康管理专家详情
                    </el-button>
                </el-table-column>
            </el-table>
        </div>

        <div class="table_message_box">
            <p style="float: left">服务健康管理对象列表</p>
            <span style="float: right;">
                <el-date-picker
                    style="height: 40px;line-height: 40px;"
                    @change="usersList"
                    v-model="search_expired_date"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="签约日期"
                    end-placeholder="签约日期"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
            </span>
            <el-table ref="multipleTable" :data="customerList" border style="width: 100%">
                <el-table-column prop="user_name" label="健康管理对象姓名" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="mobile" label="联系电话" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="start_date" label="健康管理对象签约时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="expired_date" label="协议到期时间" align="center" label-class-name="label">
                </el-table-column>
                <el-table-column prop="expired_txt" label="到期状态" align="center" label-class-name="label" v-if="role_id == 1">
                </el-table-column>
                <el-table-column label="健康管理对象状态" align="center" label-class-name="label">
                    <template slot-scope="scope">
                        {{scope.row.status == 1 ? '启用':'停用'}}
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                    <el-button :id="'hospitalEdit'" @click="goUserDetail(scope.row)" type="text" size="small">
                        详情
                    </el-button>
                </el-table-column>
            </el-table>
            <el-pagination
                class="mg-20 ta-r"
                background
                layout="total, sizes, prev, pager, next, jumper"
                :page-sizes="[5,10, 25, 50, 100]"
                :total="user_total"
                :page-size="user_perpage"
                :current-page="user_page"
                @current-change="userChangePage"
                @size-change="userChangeSite"
            ></el-pagination>
        </div>

        <div class="table_message_box">
            <p style="float: left">签约记录</p>
<!--            <span style="float: right;" v-if="role_id != 2">-->
<!--				<el-button type="success" @click="addReservation()">新增签约</el-button>-->
<!--&lt;!&ndash;				<el-button type="warning" @click="addReservation(2)">新增续约</el-button>&ndash;&gt;-->
<!--			</span>-->
            <el-table ref="multipleTable" :data="allContract" border style="width: 100%">
                <!-- <el-table-column prop="doctor_list_name" label="签约健康管理专家" align="center" label-class-name="label">
                </el-table-column> -->
<!--                <el-table-column prop="status" label="协议类型" align="center" label-class-name="label">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{ scope.row.contract_type == "1" ? '新约' : '续约' }}-->
<!--                    </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="start_date" label="健康管理助理签约时间" align="center" label-class-name="label">-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="expired_date" label="协议到期时间" align="center" label-class-name="label">-->
<!--                </el-table-column>-->
<!--                &lt;!&ndash; <el-table-column prop="status" label="缴费状态" align="center" label-class-name="label">-->
<!--                    <template slot-scope="scope">-->
<!--                        {{scope.row.status == 1 ?'已缴费':'未缴费'}}-->
<!--                    </template>-->
<!--                </el-table-column> &ndash;&gt;-->
<!--                &lt;!&ndash; <el-table-column prop="amount" label="签约费用（元）" align="center" label-class-name="label"> &ndash;&gt;-->
<!--&lt;!&ndash;                </el-table-column>&ndash;&gt;-->
<!--                <el-table-column prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">-->

<!--&lt;!&ndash;                    <el-button :id="'hospitalEdit'" @click="editOneReservationDetail(scope.row)" type="text"&ndash;&gt;-->
<!--&lt;!&ndash;                               size="small">&ndash;&gt;-->
<!--&lt;!&ndash;                        续约&ndash;&gt;-->
<!--&lt;!&ndash;                    </el-button>&ndash;&gt;-->
<!--                    <el-button :id="'hospitalEdit'" @click="editOneReservationDetail(scope.row)" type="text"-->
<!--                               size="small">-->
<!--                        编辑-->
<!--                    </el-button>-->
<!--                    <el-button :id="'hospitalEdit'" @click="oneReservationDetail(scope.row)" type="text" size="small">-->
<!--                        协议详情-->
<!--                    </el-button>-->
<!--                </el-table-column>-->

                <el-table-column prop="order_sn" label="合同协议编号" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="doctor_name" label="签约健康管理专家" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="start_date" label="签约时间" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="address" label="协议预览" align="center" label-class-name="label" v-slot="scope">
                    <div><div style="display:inline;margin-right: 2px" v-for="(img, index) in scope.row.contract_file"
                              @click="previewImage(scope.row.contract_file, index, '签约协议预览')">
                        <i class="el-icon-picture-outline"></i></div></div>
                </el-table-column>
            </el-table>
        </div>

        <div class="table_message_box">
            <div><p style="float: left">其他附件</p></div>
            <div class="detail_content doce">
                <ul class="el-upload-list el-upload-list--picture-card">
                    <li tabindex="0" class="el-upload-list__item is-ready" v-for="(img, index) in otherFileList">
                        <div>
                            <img :src="img.file" alt="" class="el-upload-list__item-thumbnail">
                            <span class="el-upload-list__item-actions" @click="previewImage(otherFileList, index, '其他附件预览')">
                                                    <span class="el-upload-list__item-preview"><i
                                                        class="el-icon-zoom-in"></i></span>
                                                </span>
                        </div>
                    </li>
                </ul>
            </div>
        </div>

        <div class="table_message_box">
            <p style="float: left">地址管理</p>
            <span style="float: right;">
				<el-button type="success" @click="addAddress(1)">新增地址</el-button>
			</span>
            <el-table ref="multipleTable" :data="allAddress" border style="width: 100%">
                <el-table-column prop="no" label="序号" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="region_name" label="所属区域" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="address" label="详细地址" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="update_date" label="更新时间" align="center"
                                 label-class-name="label"></el-table-column>
                <el-table-column prop="status" label="状态" align="center" label-class-name="label"></el-table-column>
                <el-table-column prop="is_default" label="默认地址" align="center" label-class-name="label">
                    <template slot-scope="scope">
                        {{scope.row.is_default == 1 ? "是":"否"}}
                    </template>
                </el-table-column>
                <el-table-column prop="address" label="操作" align="center" label-class-name="label" v-slot="scope">
                    <el-button :id="'hospitalEdit'" @click="editAddress(scope.row)" type="text"
                               size="small">
                        编辑
                    </el-button>
                    <el-button :id="'hospitalEdit'" @click="deleteAddress(scope.row)" type="text" size="small">
                        删除
                    </el-button>
                </el-table-column>
            </el-table>
        </div>

        <el-dialog :title="dialog_title" :visible.sync="dialogFormVisible">
            <el-form label-position="right" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="150px"
                     class="form" style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="协议" :label-width="formLabelWidth" prop="file">
                    <el-upload ref="upload" class="upload-demo" accept=".jpg,.png,.jpeg,.JPEG,.JPG,.PNG,.pdf,.PDF"
                               :action="upload_agreement_path" :file-list="fileList"
                               :on-success="handleSuccess" :before-upload="beforeAvatarUpload" list-type="picture"
                               :multiple="true" :limit="9">
                        <div slot="file" slot-scope="{file}">
                            <pdf class="el-upload-list__item-thumbnail"  v-if="file.name.endsWith('.pdf')" :src="file.url"></pdf>
                            <img v-else class="el-upload-list__item-thumbnail" :src="file.url" alt=""/>
                            <a class="el-upload-list__item-name"><i class="el-icon-document"></i>{{ file.name }}</a>
                            <label class="el-upload-list__item-status-label">
                                <i class="el-icon-upload-success el-icon-check"></i>
                            </label>
                            <i class="el-icon-close" @click="handleRemove(file)"></i>
                            <i class="el-icon-close-tip">按 delete 键可删除</i>
                        </div>

                        <el-button class="upload_btn" size="small" type="primary" v-if="addFileList.length < 9">点击上传
                        </el-button>
                        <div slot="tip" class="el-upload__tip" v-if="addFileList.length < 9">注：请上传小于5M的图片，格式支持PNG,JPG,PDF
                        </div>
                    </el-upload>

                    <div class="upload-demo">
                        <el-button class="file_view" size="small" type="primary"
                                   @click="oneReservationDetail({contract_file: JSON.stringify(addFileList)})">预览协议
                        </el-button>
                    </div>
                </el-form-item>
                <el-form-item label="签约年限" prop="year">
                    <el-select v-model="ruleForm.year" placeholder="请选择签约年限" style="width: 100%;"
                    >
                        <el-option v-for="item in allYear" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="签约日期" prop="start_date">
                    <el-date-picker v-model="ruleForm.start_date" type="date" placeholder="选择日期" format="yyyy-MM-dd"
                                    value-format="yyyy-MM-dd">
                    </el-date-picker>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addReservationData">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="dialog_title" :visible.sync="addressFormVisible">
            <el-form label-position="right" :model="addressForm" :rules="rules" ref="ruleForm" label-width="150px"
                     class="form" style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="所属区域" required>
                    <el-cascader
                        v-model="addressForm.distinct_id"
                        :options="allRegion" placeholder="请选择所属区域" style="width: 100%;"></el-cascader>
                </el-form-item>
                <el-form-item label="详细地址" required>
                    <el-input type="text" v-model="addressForm.address" placeholder="请输入详细地址" autocomplete="off"
                              style="width: 100%;"></el-input>
                </el-form-item>

                <el-form-item label="默认地址" required>
                    <el-radio-group v-model="addressForm.is_default">
                        <el-radio label="1">是</el-radio>
                        <el-radio label="2">否</el-radio>
                    </el-radio-group>
                </el-form-item>
                <el-form-item label="状态" required>
                    <el-radio-group v-model="addressForm.status">
                        <el-radio label="1">启用</el-radio>
                        <el-radio label="2">停用</el-radio>
                    </el-radio-group>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="addressFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addAddressData" v-if="addressForm.isAdd == 1">确 定</el-button>
                <el-button type="primary" @click="editAddressData" v-if="addressForm.isAdd == 0">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog title="协议详情" :visible.sync="dialogContractFormVisible">
            <el-carousel indicator-position="outside" height="500px" :autoplay="false">
                <el-carousel-item v-for="url in allContractUrls" :key="url">
                    <div class="image_box">
                        <pdf :src="url" v-if="getFileType(url) == 'pdf'"></pdf>
                        <el-image :src="url" v-else></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>

        <el-dialog :title="dialog_title" :visible.sync="dialogConsultantFormVisible">
            <el-form label-position="right" :model="consultantForm" :rules="rules" ref="consultantForm"
                     label-width="150px" class="form" style="width: 80%;margin: 20px auto 0 auto;" autocomplete="off">
                <el-form-item label="签约健康管理专家" prop="doctor_list">
                    <el-select filterable v-model="consultantForm.doctor_list" placeholder="请选择签约健康管理专家"
                               style="width: 100%;">
                        <el-option v-for="item in allAddClientContractDoctor" :key="item.user_id"
                                   :label="item.doctor_name" :value="item.user_id"></el-option>
                    </el-select>
                </el-form-item>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="dialogConsultantFormVisible = false">取 消</el-button>
                <el-button type="primary" @click="addConsultantData">确 定</el-button>
            </div>
        </el-dialog>

        <el-dialog :title="preview_title" :visible.sync="dialogImgFormVisible">
            <el-carousel ref="image_box" id="image_detail" indicator-position="outside" height="500px" :autoplay="false" :initial-index="0" :loop="false">
                <el-carousel-item v-for="(url, n) in imageUrl" :key="n">
                    <div class="image_box" v-if="getFileType(url.src) == 'pdf'">
                        <pdf
                            v-for="i in url.pages"
                            :key="i"
                            :page="i"
                            :src="url.src" ></pdf>{{url.src}}
                    </div>
                    <div class="image_box" v-if="getFileType(url.src) != 'pdf'">
                        <el-image :src="url.src"></el-image>
                    </div>
                </el-carousel-item>
            </el-carousel>
        </el-dialog>
    </div>
</template>
<script>
import env from "@/api/env";
import Box from "@/components/Box.vue";
import {
    check
} from "@/utils/checkData";
import {getUserInfos} from "@/utils/userInfos";
import {authUrlCheck, base64Parser, fileType, getBase64Image, loadFile} from "@/api/order";
import PizZip from "pizzip";
import Docxtemplater from "docxtemplater";
import {saveAs} from "file-saver";
import ImageModule from "docxtemplater-image-module-free";
import pdf from "vue-pdf";

export default {
    components: {
        Box,
        pdf
    },
    data() {
        return {
            role_id: 0,
            child_role_id: 0,
            admin_user_name: '',
            admin_user_mobile: '',
            company_name: '',
            company_group_name: '',
            company_department_name: '',
            allContractUrls: [],
            editId: '',
            isAdd: 1, // 1：添加；0：编辑;
            isShowVoucherImg: 0,
            isAddClientContractDoctor: 1, // 1：添加；2编辑；
            search_expired_date: [],
            is_offline: 0,
            dialogFormVisible: false,
            addressFormVisible: false,
            dialogConsultantFormVisible: false,
            dialogContractFormVisible: false,
            imgUrl: env.IMG_COMMON_URL_PREFIX,
            dialog_title: '新增签约',
            userVoucherImgUrl: '',
            user_id: '',
            offlineDisabled: false,
            upload_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=1',
            upload_agreement_path: env.IMG_COMMON_REQUEST_URL_PREFIX + '?type=99',
            otherFileList: [], // 其他附件
            fileList: [],
            addFileList: [],
            search_reservation_data: '',
            user_avatar: '',
            user_avarar_form: '',
            user_name: '',
            introduction: '',
            status: '',
            status_num: 0,
            company_id: '',
            doctor_id: '',
            doctor_name: '',
            doctor_status: '',
            doctor_mobile: '',
            idcard: '',
            bank_card: '',
            manager_name: '',
            hospital_name: '',
            title_name: '',
            mobile: '',
            company_group_id: '',
            company_department_id: '',
            posistion: '',
            expired_date: '',
            start_date: '',
            is_expired: '',
            nick_name: '',
            client_doctor_number: 0,
            user_assistant_number: 0,
            health_records_number: 0,
            needDeal: 0,
            noReplyCount: 0,
            beforeMeetCount: 0,
            brokenMeetCount: 0,
            finishMeet: 0,
            service_total: 0,
            service_perpage: 5,
            service_page: 1,
            user_total: 0,
            user_perpage: 5,
            user_page: 1,
            allAddClientContractDoctor: [],
            customerList: [], // 顾客列表
            bindedDoctor: [], // 健康管理专家列表
            allContract: [], // 签约记录
            allAddress: [], // 健康管理专家地址列表
            allRegion: [], // 地区数据
            reservationListing: [],
            imageUrl: [],
            dialogImgFormVisible: false,
            preview_title: '',
            isedit: false,
            ruleForm: {
                file: "",
                year: '',
                start_date: '',
                amount: '',
                doctor_list: '',
                voucher_img: '',
                contract_type: '',
                is_offline: 1,
                is_paid: 1,
            },
            consultantForm: {
                expired_date: '',
                doctor_list: '',

            },
            addressForm: {
                isAdd: 0,
                id: "",
                doctor_id: "",
                address: "",
                distinct_id: "",
                status: '1',
                is_default: "2", // 是否默认地址,2否
            },
            rules: {
                file: [{
                    required: true,
                    message: "请上传协议",
                    trigger: "blur"
                },],
                year: [{
                    required: true,
                    message: "请选择年限",
                    trigger: "blur"
                },],
                start_date: [{
                    required: true,
                    message: "请选择签约日期",
                    trigger: "blur"
                },],
                amount: [{
                    required: true,
                    message: "请输入签约金额",
                    trigger: "blur"
                },],
                //doctor_list: [
                //    {required: true, message: "请选择专家", trigger: "blur"},
                //],
                is_paid: [{
                    required: true,
                    message: "请输入是否缴费",
                    trigger: "blur"
                },],
            },
            allYear: [{
                id: 1,
                name: '一年'
            },
                {
                    id: 2,
                    name: '二年'
                },
                {
                    id: 3,
                    name: '三年'
                }
            ],
            formLabelWidth: '120px',
            is_submit: false,
        };
    },
    created() {
        let prev_page = localStorage.getItem('prev_page')

        if (prev_page == 'manager_edit') {
            this.user_id = localStorage.getItem('manager_detail_user_id')

            setTimeout(()=>{
                this.managerDetail();
            }, 100)
        } else {
            let userInfo = getUserInfos()
            if (userInfo) {
                this.role_id = parseInt(userInfo.role_id)
                this.child_role_id = parseInt(userInfo.child_role_id)
            }
            if (this.$route.query.user_id) {
                this.user_id = this.$route.query.user_id;
            } else {
                this.user_id = this.$route.params.user_id;
                this.user_name = this.$route.params.user_name;
                this.mobile = this.$route.params.mobile;
                this.company_name = this.$route.params.company_name;
                this.company_department_name = this.$route.params.company_department_name;
                this.company_group_name = this.$route.params.company_group_name;
                this.status = this.$route.params.status;
            }
            this.managerDetail();
        }
        localStorage.setItem('prev_page', 'manager_detail')


    },
    mounted() {
    },
    methods: {
        // 获取医生详情资料
        managerDetail() {

            let params = {
                servername: 'Ruyi_AssistantAdminServices',
                method: 'assistantDetail',
                params: {
                    user_id: this.user_id,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }

                let data = res.data.data.assistant_detail

                this.mobile = data.mobile;
                this.company_name = data.company_name;
                this.company_department_name = data.department_name;
                this.company_group_name = data.group_name;

                this.user_name = res.data.data.assistant_detail.user_name;
                this.company_id = res.data.data.assistant_detail.company_id;
                this.company_department_id = res.data.data.assistant_detail.company_department_id;
                this.company_group_id = res.data.data.assistant_detail.company_group_id;
                this.status = res.data.data.assistant_detail.status;
                this.introduction = res.data.data.assistant_detail.introduction;
                this.posistion = res.data.data.assistant_detail.posistion;
                this.hospital_name = res.data.data.assistant_detail.hospital_name
                this.title_name = res.data.data.assistant_detail.title_name
                this.admin_user_name = res.data.data.assistant_detail.operate_user_name
                this.admin_user_mobile = res.data.data.assistant_detail.operate_user_mobile
                switch (res.data.data.assistant_detail.status) {
                    case '1':
                        this.status = '启用';
                        this.status_num = 1;
                        break;
                    case '2':
                        this.status = '停用';
                        this.status_num = 2;
                        break;
                }
                if (res.data.data.assistant_detail.user_avatar) {
                    this.user_avarar_form = res.data.data.assistant_detail.user_avatar;
                    this.user_avatar = this.imgUrl + res.data.data.assistant_detail.user_avatar;
                }
                this.idcard = res.data.data.assistant_detail.idcard;
                this.bank_card = res.data.data.assistant_detail.bank_card;
                this.expired_date = res.data.data.assistant_detail.expired_date
                this.start_date = res.data.data.assistant_detail.start_date

                // 服务健康管理专家
                if (res.data.data.bindedDoctor) {

                    this.doctor_id = res.data.data.bindedDoctor.user_id;
                    this.doctor_name = res.data.data.bindedDoctor.user_name;
                    this.doctor_status = res.data.data.bindedDoctor.status;
                    this.doctor_mobile = res.data.data.bindedDoctor.mobile;
                    let myDoctor = res.data.data.bindedDoctor;
                    myDoctor.status = myDoctor.status == 1 ? "启用" : "停用";
                    myDoctor.no = 1;
                    this.bindedDoctor = new Array();
                    this.bindedDoctor.push(myDoctor);
                }

                // 服务健康管理专家地址
                if (res.data.data.bindedAddress) {
                    this.allAddress = res.data.data.bindedAddress;
                    for (var i = 0; i < this.allAddress.length; i++) {
                        this.allAddress[i].status_number = this.allAddress[i].status;
                        this.allAddress[i].no = i + 1;
                        switch (this.allAddress[i].status) {
                            case '1':
                                this.allAddress[i].status = '启用';
                                break;
                            case '2':
                                this.allAddress[i].status = '停用';
                                break;

                        }
                    }
                }

                this.needDeal = res.data.data.needDeal;
                this.noReplyCount = res.data.data.noReplyCount;
                this.beforeMeetCount = res.data.data.beforeMeetCount;
                this.brokenMeetCount = res.data.data.brokenMeetCount;
                this.finishMeet = res.data.data.finishMeet;

                // 其他附件：身份证银行卡照片
                let allFile = [];
                if (res.data.data.assistant_detail.idcard_img_up) {
                    allFile.push({
                        name: '身份证正面照片',
                        file: this.imgUrl + res.data.data.assistant_detail.idcard_img_up
                    });
                }

                if (res.data.data.assistant_detail.idcard_img_down) {
                    allFile.push({
                        name: '身份证反面照片',
                        file: this.imgUrl + res.data.data.assistant_detail.idcard_img_down
                    });
                }
                if (res.data.data.assistant_detail.bankcard_img) {
                    allFile.push({
                        name: '银行卡照片',
                        file: this.imgUrl + res.data.data.assistant_detail.bankcard_img
                    });
                }
                this.otherFileList = allFile;

                let image_file = [];
                let image_res = [];
                if (res.data.data.assistantLastContract) {
                    for (let i = 0; i < res.data.data.assistantLastContract.length; i++) {
                        if (res.data.data.assistantLastContract[i].doctor_id != this.doctor_id) {
                            res.data.data.assistantLastContract[i].doctor_name += '(已解除绑定)'
                        }
                        image_file = JSON.parse(res.data.data.assistantLastContract[i].contract_file)
                        for (let j = 0; j < image_file.length; j++) {
                            image_res.push({
                                file: this.imgUrl + image_file[j].file
                            })
                        }

                        res.data.data.assistantLastContract[i].contract_file = image_res

                    }
                }
                this.allContract = res.data.data.assistantLastContract;
                this.reservationListingMethod();
                this.usersList();
            });
        },

        // 预约信息列表
        reservationListingMethod() {
            //alert(this.doctor_id);
            let params = {
                servername: 'Ruyi_AssistantAdminServices',
                method: 'userReservationList',
                params: {
                    user_id: this.user_id,
                    doctor_id: this.doctor_id,
                    search_reservation_data: this.search_reservation_data,
                },
                pageinfo: {
                    page: this.service_page,
                    perpage: this.service_perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                if (res.data.data.list) {
                    for (var i = 0; i < res.data.data.list.length; i++) {
                        switch (res.data.data.list[i].status) {
                            case '1':
                                res.data.data.list[i].status = '预约处理';
                                break;
                            case '2':
                                res.data.data.list[i].status = '等待会面';
                                break;
                            case '3':
                                res.data.data.list[i].status = '会面完成';
                                break;
                            case '4':
                                res.data.data.list[i].status = '会面中断';
                                break;
                        }
                    }
                    this.reservationListing = res.data.data.list;
                    this.service_total = res.data.data.page.count;
                }

            });
        },

        // 返回上一页
        goBack() {
            window.history.go(-1);
            return;
        },

        serviceChangePage(index) {
            this.service_page = index;
            this.reservationListingMethod();
        },

        serviceChangeSite(index) {
            this.service_perpage = index;
            this.reservationListingMethod();
        },

        // 跳转编辑
        edit() {
            this.$router.push({
                name: "managerEdit",
                params: {
                    user_id: this.user_id,
                    user_name: this.user_name,
                    user_avatar: this.user_avarar_form,
                    mobile: this.mobile,
                    idcard: this.idcard,
                    company_id: this.company_id,
                    company_department_id: this.company_department_id,
                    company_group_id: this.company_group_id,
                    status: this.status_num,
                }
            });
        },

        // 搜索预约信息
        searchReservation() {
            this.service_page = 1;
            this.reservationListingMethod();
        },

        // 查看更多预约
        goReservationListing() {
            this.$router.push({
                name: "workList",
                params: {manager_name: this.user_name}
            });
        },

        // 打开添加地址弹窗
        addAddress() {
            this.addressForm.address = '';
            this.addressForm.distinct_id = '';
            this.addressForm.status = "1"
            this.addressForm.is_default = "2"
            this.isedit = false;
            this.dialog_title = '添加健康管理专家地址';
            this.addressForm.isAdd = 1;
            this.fileList = [];
            this.addFileList = [];
            this.editId = '';

            this.getallRegion()

            this.$nextTick(() => {
                this.addressFormVisible = true;
            });
        },
        // 打开编辑地址弹窗
        editAddress(data) {
            this.isedit = true;
            this.dialog_title = '编辑地址';
            this.editId = data.id;
            this.addressForm.isAdd = 0;
            this.addressForm.id = data.id
            this.addressForm.doctor_id = data.doctor_id;
            this.addressForm.address = data.address;
            this.addressForm.distinct_id = data.distinct_id
            this.addressForm.status = data.status_number
            this.addressForm.is_default = data.is_default
            this.getallRegion()
            this.$nextTick(() => {
                this.addressFormVisible = true;
            })
        },
        // 打开添加预约弹窗
        addReservation() {
            let type = 1;
            if (this.allContract.length > 0) {
                type = 2
            } else {
                type = 1
            }
            this.isedit = false;
            this.dialog_title = type == 1 ? '新增签约' : '新增续约';
            this.isAdd = 1;
            this.isShowVoucherImg = 0;
            this.fileList = [];
            this.addFileList = [];
            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            }


            this.ruleForm.file = '';
            this.ruleForm.year = '';
            this.ruleForm.start_date = '';
            this.ruleForm.amount = '';
            this.ruleForm.contract_type = type;
            //this.ruleForm.doctor_list = '';
            //this.ruleForm.voucher_img = '';
            this.userVoucherImgUrl = '';
            //this.ruleForm.is_offline = 1;
            this.ruleForm.is_paid = 1;
            this.editId = '';


            this.$nextTick(() => {
                this.dialogFormVisible = true;
            });
        },

        // 打开添加健康管理专家弹窗
        addConsultant() {
            this.isedit = false;
            if (this.doctor_id) {
                this.dialog_title = '重新绑定健康管理专家';
            } else {
                this.dialog_title = '新增健康管理专家';
            }
            this.isAdd = 1;

            this.consultantForm.expired_date = '';
            this.consultantForm.doctor_list = '';
            this.editId = '';

            let params = {
                servername: 'Ruyi_AdminCustomerServices',
                method: 'allDoctor',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allAddClientContractDoctor = res.data.data;
                this.$nextTick(() => {
                    this.dialogConsultantFormVisible = true;
                })
            });
        },

        // 打开编辑弹框
        editOneReservationDetail(data) {
            this.isedit = true;
            this.dialog_title = '编辑签约';
            this.editId = data.id;
            this.isAdd = 0;
            this.fileList = [];
            this.addFileList = [];
            this.ruleForm.file = '';
            this.ruleForm.year = '';
            this.ruleForm.start_date = '';
            this.ruleForm.amount = '';
            this.ruleForm.doctor_list = '';
            this.ruleForm.voucher_img = '';
            this.userVoucherImgUrl = '';
            this.ruleForm.is_offline = 1;
            this.isShowVoucherImg = 0;

            if (this.$refs.upload) {
                this.$refs.upload.clearFiles();
            }

            var allFile = [];
            if (data.contract_file && data.contract_file != '' && data.contract_file != null) {
                var contract_file = JSON.parse(data.contract_file);
                if (contract_file.length == 0) {
                    this.addFileList = [];
                    this.fileList = [];
                } else {
                    this.addFileList = contract_file;

                    for (var i = 0; i < contract_file.length; i++) {
                        let index = contract_file[i].file.lastIndexOf("/");
                        let name = contract_file[i].file.substring(index + 1, contract_file[i].file.length);
                        let oneContract = {
                            name: name,
                            url: this.imgUrl + contract_file[i].file,
                            x: contract_file[i].x,
                            y: contract_file[i].y,
                        };
                        allFile.push(oneContract);
                        this.ruleForm.file = "file";
                    }
                }
            }

            this.fileList = allFile;


            // 渲染图片成功之后
            this.$nextTick(() => {
                let params = {
                    servername: 'Ruyi_AdminCustomerServices',
                    method: 'allDoctor',
                    params: {
                        user_client_contract_id: data.id
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        return;
                    }
                    //this.allAddClientContractDoctor = res.data.data;
                    this.ruleForm.year = parseInt(data.year);
                    this.ruleForm.amount = data.amount;
                    this.ruleForm.start_date = data.start_date;
                    this.ruleForm.is_paid = data.status;

                    this.$nextTick(() => {
                        this.dialogFormVisible = true;
                    })
                });
            })
        },

        // 调用接口，添加协议
        addReservationData() {
            this.$refs["ruleForm"].validate(valid => {
                if (this.is_submit) {
                    // 重复提交提醒
                    this.$message({
                        type: "warning",
                        message: '正在处理请求，请不要重复提交',
                        duration: 1500,
                    });
                    return;
                }
                this.is_submit = true;
                if (valid) {
                    if (this.isAdd == 1) {
                        // 新增预约
                        let params = {
                            servername: 'Ruyi_AssistantAdminServices',
                            method: 'createUserManagerContract',
                            params: {
                                user_id: this.user_id,
                                contract_file: this.addFileList,
                                year: this.ruleForm.year,
                                start_date: this.ruleForm.start_date,
                                amount: this.ruleForm.amount,
                                status: this.ruleForm.is_paid,
                                contract_type: this.ruleForm.contract_type,
                                //is_offline: this.ruleForm.is_offline,
                                //voucher_img: this.ruleForm.voucher_img,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            if (res.data.code != '0') {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg,
                                    duration: 1500,
                                });
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '新增成功',
                                duration: 1500
                            });
                            this.dialogFormVisible = false;
                            this.managerDetail();
                            this.is_submit = false;
                        }).catch(()=>{
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });
                    } else {
                        // 编辑预约
                        let params = {
                            servername: 'Ruyi_AssistantAdminServices',
                            method: 'editUserManagerContract',
                            params: {
                                id: this.editId,
                                user_id: this.user_id,
                                contract_file: this.addFileList,
                                year: this.ruleForm.year,
                                start_date: this.ruleForm.start_date,
                                amount: this.ruleForm.amount,
                                status: this.ruleForm.is_paid,
                            }
                        };
                        this.$api.service(params).then(res => {
                            if (!check(res)) {
                                this.is_submit = false;
                                return;
                            }
                            if (res.data.code != '0') {
                                this.$message({
                                    type: "error",
                                    message: res.data.msg,
                                    duration: 1500,
                                });
                                this.is_submit = false;
                                return;
                            }
                            this.$message({
                                type: "success",
                                message: '编辑成功',
                                duration: 1500
                            });
                            this.dialogFormVisible = false;
                            this.managerDetail();
                            this.is_submit = false;
                        }).catch(()=>{
                            this.is_submit = false;
                        }).finally(() => {
                            this.is_submit = false;
                        });

                    }
                }
            })

        },
        userChangeSite(index) {
            this.user_perpage = index;
            this.usersList();
        },
        userChangePage(index) {
            this.user_page = index;
            this.usersList();
        },
        // 服务健康管理对象列表
        async usersList() {

            if (this.is_submit) {
                return;
            }
            this.is_submit = true;
            let start_date = '';
            let end_date = '';
            if (this.search_expired_date) {
                start_date = this.search_expired_date[0]
                end_date = this.search_expired_date[1]
            }
            let params = {
                servername: 'Ruyi_AssistantAdminServices',
                method: 'userList',
                params: {
                    doctor_id: this.doctor_id,
                    start_start_date: start_date,
                    end_start_date: end_date,
                },
                pageinfo: {
                    page: this.user_page,
                    perpage: this.user_perpage,
                },
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                if (res.data.data.list) {
                    this.customerList = res.data.data.list;
                    this.user_total = res.data.data.page.count
                }

                this.is_submit = false;
            }).catch(()=>{
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },
        // 地址表单数据校验
        addressFormDataCheck() {
            if (!this.addressForm.distinct_id[0] || !this.addressForm.distinct_id[1] || !this.addressForm.distinct_id[1]) {
                this.$message({
                    type: "error",
                    message: '请选择所属区域',
                    duration: 1500,
                });
                this.addressForm.distinct_id.blur()
                return;
            }

            if (!this.addressForm.address) {
                this.$message({
                    type: "error",
                    message: '请输入详细地址',
                    duration: 1500,
                });
                this.addressForm.address.blur()
                return;
            }
            if (!this.addressForm.status) {
                this.$message({
                    type: "error",
                    message: '请选择状态',
                    duration: 1500,
                });
                return;
            }

            if (!this.addressForm.is_default) {
                this.$message({
                    type: "error",
                    message: '请选择默认地址状态',
                    duration: 1500,
                });
                return;
            }
            return true;
        },
        // 调用接口，添加地址
        addAddressData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (!this.addressFormDataCheck()) {
                this.is_submit = false;
                return;
            }
            // 新增地址
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'createAddress',
                params: {
                    doctor_id: this.doctor_id,
                    address: this.addressForm.address,
                    status: this.addressForm.status,
                    province_id: this.addressForm.distinct_id[0],
                    city_id: this.addressForm.distinct_id[1],
                    distinct_id: this.addressForm.distinct_id[2],
                    is_default: this.addressForm.is_default,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    this.is_submit = false;
                    return;
                }
                this.$message({
                    type: "success",
                    message: '新增成功',
                    duration: 1500
                });
                this.addressFormVisible = false;
                this.managerDetail();
                this.is_submit = false;
            }).catch(()=>{
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });

        },
        // 调用接口，编辑地址
        editAddressData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (!this.addressFormDataCheck()) {
                this.is_submit = false;
                return;
            }
            // 修改地址
            let params = {
                servername: 'Ruyi_AdminNewOperateServices',
                method: 'editAddress',
                params: {
                    id: this.addressForm.id,
                    doctor_id: this.addressForm.doctor_id,
                    address: this.addressForm.address,
                    status: this.addressForm.status,
                    province_id: this.addressForm.distinct_id[0],
                    city_id: this.addressForm.distinct_id[1],
                    distinct_id: this.addressForm.distinct_id[2],
                    is_default: this.addressForm.is_default,
                }
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    this.is_submit = false;
                    return;
                }
                if (res.data.code != '0') {
                    this.$message({
                        type: "error",
                        message: res.data.msg,
                        duration: 1500,
                    });
                    this.is_submit = false;
                    return;
                }
                this.$message({
                    type: "success",
                    message: '修改成功',
                    duration: 1500
                });
                this.addressFormVisible = false;
                this.managerDetail();
                this.is_submit = false;
            }).catch(()=>{
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });

        },

        // 删除地址
        deleteAddress(data) {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            this.$confirm('确定删除该地址吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                let params = {
                    servername: 'Ruyi_AdminNewOperateServices',
                    method: 'deleteAddress',
                    params: {
                        id: data.id,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                    } else {
                        this.$message({
                            type: "success",
                            message: '删除成功',
                            duration: 1500,
                        });
                    }
                    this.managerDetail();
                    this.is_submit = false;
                }).catch(() => {
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }).catch(() => {
                this.is_submit = false;
            }).finally(() => {
                this.is_submit = false;
            });
        },

        // 调用接口，添加健康管理专家或编辑健康管理专家
        addConsultantData() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复提交',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            if (this.consultantForm.doctor_list == '') {
                this.$message({
                    type: "error",
                    message: '请选择服务健康管理专家',
                    duration: 1500
                });
                this.is_submit = false;
            } else {
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'bindingAssistant',
                    params: {
                        user_id: this.user_id,
                        doctor_id: this.consultantForm.doctor_list,
                        type: 1,
                    }
                };
                this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }
                    if (res.data.code != '0') {
                        this.$message({
                            type: "error",
                            message: res.data.msg,
                            duration: 1500,
                        });
                        this.is_submit = false;
                        return;
                    }
                    this.$message({
                        type: "success",
                        message: '绑定成功',
                        duration: 1500
                    });
                    this.dialogConsultantFormVisible = false;
                    this.managerDetail();
                    this.is_submit = false;
                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            }
            // 新增预约


        },

        // 除去图片
        handleRemove(file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                        };
                        addFileList.push(obj);
                    }
                }
            }
            this.addFileList = addFileList;
            this.ruleForm.file = "";
        },

        // 上传图片成功
        handleSuccess(response, file, fileList) {
            var addFileList = [];
            var imageUrl = this.imgUrl;
            for (var i = 0; i < fileList.length; i++) {
                if (fileList[i].status == 'success') {
                    if (fileList[i].response && fileList[i].response.data) {
                        addFileList.push(fileList[i].response.data);
                    } else {
                        let name = fileList[i].url.substring(imageUrl.length, fileList[i].url.length);
                        let obj = {
                            file: name,
                            x: fileList[i].x,
                            y: fileList[i].y,
                        };
                        addFileList.push(obj);
                    }
                }
            }
            this.addFileList = addFileList;
            this.ruleForm.file = "file";
        },

        // 协议详情
        oneReservationDetail(data) {
            this.allContractUrls = [];
            let allContractUrls = [];
            if (data.contract_file) {
                let contract_file = JSON.parse(data.contract_file);
                if (contract_file.length > 0) {
                    for (let i = 0; i < contract_file.length; i++) {
                        let url = this.imgUrl + contract_file[i].file;
                        allContractUrls.push(url);
                    }
                }
            }
            this.allContractUrls = allContractUrls;
            this.dialogContractFormVisible = true;
        },
        getFileType(url) {
            return fileType(url)
        },
        // 跳转专家详情
        goDoctorDetail(data) {
            if (this.role_id > 1) {
                if (!authUrlCheck('/admin/doctor/DoctorDetail', this.$store.getters.authUrl)) {
                    return;
                }
            }
            this.$router.replace({
                name: "doctorDetail",
                query: {
                    user_id: data.user_id
                }
            });
            return;

        },
        goUserDetail(data) {
            this.$router.push({
                name: "userDetail",
                query: {user_id: data.user_id}
            });
        },

        //  切换是否线下缴费
        /*changeIsOffline() {
            if (this.ruleForm.is_offline == 2) {
                this.isShowVoucherImg = 1;
            } else {
                this.isShowVoucherImg = 0;
            }
        },*/

        // 上传身份证正面图片
        handleUserAvatarImgSuccess(res) {
            if (res.code == 0) {
                this.ruleForm.voucher_img = res.data;
                this.userVoucherImgUrl = this.imgUrl + res.data;
            } else {
                this.$message({
                    type: "error",
                    message: res.msg,
                });
            }
        },

        //上传图片之前，检测文件格式
        beforeAvatarUpload(file) {
            if (file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'application/pdf') {
                var isJPG = true;
            } else {
                var isJPG = false;
            }
            const isLt5M = file.size / 1024 / 1024 < 5;
            if (!isJPG) {
                this.$message.error('图片只能是jpg/png/pdf格式!');
            }
            if (!isLt5M) {
                isJPG = false;
                this.$message.error('图片大小不能超过5MB!');

            }
            return isJPG;
        },
        goAssistan() {
            this.$router.push({
                path: "/admin/user/AssistantList",
                query: {
                    user_name: this.user_name
                }
            });
            //跳转到子帐户列表页

        },
        goHealthRecord() {
            this.$router.push({
                path: "/admin/user/HealthrecordsList",
                query: {
                    user_name: this.user_name
                }
            });
            //跳转到子帐户列表页

        },
        // 所有地区
        getallRegion() {
            let params = {
                servername: 'Ruyi_AdminOperateServices',
                method: 'allRegion',
            };
            this.$api.service(params).then(res => {
                if (!check(res)) {
                    return;
                }
                this.allRegion = res.data.data;
            });
        },
        amountCheck(e) {
            if (e < 0) {
                this.$message({
                    message: '签约金额不能小于0',
                    type: 'error'
                });
                this.ruleForm.amount = 0;
                return;
            }
            if (!e || isNaN(e)) {
                this.ruleForm.amount = 0;
            } else {
                this.ruleForm.amount = parseInt(e);
            }

        },


        // 健康管理助理资料导出到word
        async importinfo() {
            if (this.is_submit) {
                // 重复提交提醒
                this.$message({
                    type: "warning",
                    message: '正在处理请求，请不要重复操作',
                    duration: 1500,
                });
                return;
            }
            this.is_submit = true;
            let newDataArr = [];
            let doctors = [];
            let users = [];
            let contracts = [];
            let type_name = '';
            let _that = this
            let user_name = this.user_name
            // 健康管理专家
            for (let i=0; i< this.bindedDoctor.length;i++) {
                doctors.push({
                    name: this.bindedDoctor[i].user_name,
                    mobile: this.bindedDoctor[i].mobile,
                    status: this.bindedDoctor[i].status,
                    hospital: this.bindedDoctor[i].hospital_name,
                    department: this.bindedDoctor[i].department_name,
                })
            }

            // 健康管理对象
            if (this.user_total > this.user_perpage) {
                let start_date = '';
                let end_date = '';

                if (this.search_expired_date) {
                    start_date = this.search_expired_date[0]
                    end_date = this.search_expired_date[1]
                }
                let params = {
                    servername: 'Ruyi_AssistantAdminServices',
                    method: 'userList',
                    params: {
                        doctor_id: this.doctor_id,
                        start_start_date: start_date,
                        end_start_date: end_date,
                    },
                };
                await this.$api.service(params).then(res => {
                    if (!check(res)) {
                        this.is_submit = false;
                        return;
                    }

                    for (let i=0; i< res.data.data.list.length;i++) {
                        users.push({
                            name: res.data.data.list[i].user_name,
                            mobile: res.data.data.list[i].mobile,
                            start_date: res.data.data.list[i].start_date,
                            end_date: res.data.data.list[i].expired_date,
                        })
                    }

                }).catch(()=>{
                    this.is_submit = false;
                }).finally(() => {
                    this.is_submit = false;
                });
            } else {
                for (let i=0; i< this.customerList.length;i++) {
                    users.push({
                        name: this.customerList[i].user_name,
                        mobile: this.customerList[i].mobile,
                        start_date: this.customerList[i].start_date,
                        end_date: this.customerList[i].expired_date,
                    })
                }
            }


            // 签约记录
            for (let i=0; i< this.allContract.length;i++) {
                type_name = this.allContract[i].contract_type == "1" ? '新约' : '续约';
                contracts.push({
                    type: type_name,
                    start_date: this.allContract[i].start_date,
                    end_date: this.allContract[i].expired_date,
                })
            }
            let doctor_status = '';
            if (this.doctor_id) {
                doctor_status = this.doctor_status == 1 ? '启用' : '停用';
            }
            newDataArr.push({
                "avatar": await getBase64Image(this.user_avatar),
                "user_name": this.user_name,
                "hospital_name": this.hospital_name || '',
                "title_name": this.title_name || '',
                "status": this.status,
                "doctor_name": this.doctor_name || ' ',
                "doctor_mobile": this.doctor_mobile || ' ',
                "doctor_status": doctor_status,
                "idcard": this.idcard || ' ',
                "company_name": this.company_name || ' ',
                "mobile": this.mobile || ' ',
                "department": this.company_department_name || ' ',
                "expired_date": this.expired_date || ' ',
                "group": this.company_group_name || ' ',
                "need_deal_num": this.needDeal || 0,
                "no_reply_num": this.noReplyCount || 0,
                "before_meet_num": this.beforeMeetCount || 0,
                "int_num": this.brokenMeetCount || 0,
                "succ_num": this.finishMeet || 0,
                "doctor": doctors,
                "user": users,
                "contracts": contracts,
            })

            loadFile(
                "detail-manager.docx",
                function (error, content) {

                    if (error) {
                        this.is_submit = false;
                        throw error;
                    }

                    const zip = new PizZip(content);

                    let imageOpts = {}
                    imageOpts.centered = true;  // 图片居中，在word模板中定义方式为{%%image}
                    imageOpts.fileType = "docx";
                    imageOpts.getImage = function (newImgUrl) {
                        return base64Parser(newImgUrl);
                    }
                    imageOpts.getSize = function () {
                        return [190, 190]
                    }

                    const doc = new Docxtemplater(zip, {
                        paragraphLoop: true,
                        linebreaks: true,
                        modules: [new ImageModule(imageOpts)],
                    });

                    doc.render({
                        "manager_info": newDataArr
                    });

                    const out = doc.getZip().generate({
                        type: "blob",
                        mimeType:
                            "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
                    });
                    // Output the document using Data-URI
                    saveAs(out, `健康管理助理资料-${user_name}.docx`);
                    setTimeout(function () {
                        _that.is_submit = false;
                    }, 1500)
                }
            );

        },
        // 预览
        async previewImage(data, index, title){
            if (this.$refs.image_box) {
                this.$refs.image_box.setActiveItem(index)
            }
            this.imageUrl = [];

            if (data.length > 0) {
                let url = '';
                let local_url = '';
                let num_pages = 0;
                for (let i = 0; i < data.length; i++) {
                    // this.imageUrl.push(data[i].file);
                    local_url = url = data[i].file;
                    num_pages = 0;
                    if (this.getFileType(url) == 'pdf') {
                        url = pdf.createLoadingTask(url)
                        await url.promise.then(pdf => {
                            num_pages = pdf.numPages
                            this.imageUrl.push({
                                src: local_url,
                                pages: num_pages
                            });
                        }).catch((e)=>{});

                    } else {
                        this.imageUrl.push({
                            src: local_url,
                            pages: num_pages
                        });
                    }
                }
            }
            this.preview_title = title
            this.active_index = index
            this.dialogImgFormVisible = true;

        },
    }
};
</script>
<style lang="scss">
@import "@/styles/common.scss";

.avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
}

.avatar-uploader .el-upload:hover {
    border-color: #409EFF;
}

.avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 316px;
    height: 200px;
    line-height: 200px;
    text-align: center;
}

.avatar {
    width: 316px;
    height: 200px;
    display: block;
}

.docker-detail-header {
    text-align: right;
    margin: 20px 0 20px 0;

    .el-button {
        height: 32px;
        line-height: 6px;
    }
}

.table .dockert_img_td {
    width: 22% !important;
    padding: 10px;
    text-align: center;
}

.table .docker_title_td {
    width: 10% !important;
    padding-right: 10px;
    text-align: right;
    background-color: #f9fafd;
}

.table .docker_value_td {
    width: 28% !important;
}

.message_box .message_title {
    text-align: left;
    font-size: 16px;
}

.message_box table {
    border-collapse: collapse !important;
    color: #606266;
    border-left: 1px solid #ebeef5;
    border-bottom: 1px solid #ebeef5;
    border-right: 1px solid #ebeef5;
}

.message_box table tbody {
    display: table-row-group;
    vertical-align: middle;
    border-color: inherit;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr:nth-child(1) {
    background-color: #f9fafd;
}

.message_box table tr {
    display: table-row;
    vertical-align: inherit;
    border-color: inherit;
}

.message_box table tr > td:first-of-type {
    border-left: 0;
    border-bottom: 0;
}

.message_box table tr td {
    border-left: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    font-size: 14px;
    padding: 15px 0 15px 10px;
    width: auto !important;
    text-align: center;
}

.table_message_box {
    margin: 50px 0px 20px 0px;
}

.search_data {
    float: right;
    margin: 15px 0px 15px 0px;
    width: 20%;
}

.image_box {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}

.upload_btn {
    position: absolute;
    top: 0;
    left: 30px;
}

.file_view {
    position: absolute;
    top: 0;
    left: 130px;
}
.el-icon-picture-outline{color: #6B99F0;cursor: pointer;}
.doce {
    width: 100%;
    display: flex;
    margin-top: 55px;
    padding-left: 90px;
    box-sizing: border-box;
}
.image_box {
    height: 500px;
    overflow: hidden;
    overflow-y: auto;

    image {
        width: 100%;
    }
}
</style>
